import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'accent' | 'success' | 'warn' | 'error' | 'info' | 'purple';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const tones: Record<Tone, string> = {
  neutral: 'bg-[var(--color-bg-elevated)] text-[var(--color-fg-muted)]',
  accent: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-ink)]',
  success: 'bg-[color-mix(in_srgb,var(--color-success)_10%,transparent)] text-[var(--color-success)]',
  // Ink twin, not the fill: --color-warn as a label measured 2.9:1 here.
  warn: 'bg-[color-mix(in_srgb,var(--color-warn)_10%,transparent)] text-[var(--color-warn-ink)]',
  error: 'bg-[color-mix(in_srgb,var(--color-error)_10%,transparent)] text-[var(--color-error)]',
  info: 'bg-[color-mix(in_srgb,var(--color-info)_10%,transparent)] text-[var(--color-info)]',
  purple: 'bg-[var(--color-accent-10)] text-[var(--color-accent-ink)]',
};

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide',
        tones[tone],
        className,
      )}
      {...rest}
    />
  );
}
